import {Component, input, OnChanges} from '@angular/core'
import {NgxEchartsDirective, provideEchartsCore} from 'ngx-echarts'
import * as echarts from 'echarts/core'
import {EChartsType} from 'echarts/core'
import {PieChart} from 'echarts/charts'
import {GridComponent, TooltipComponent} from 'echarts/components'
import {CanvasRenderer} from 'echarts/renderers'

import {EChartsOption} from 'echarts'
import {KalpLoan} from '../../model/kalp-loan'
import {COLOR_LIST} from '../../application/data-types'
import {PrintableChartComponent} from '../../common/printable-chart/printable-chart.component'


echarts.use([PieChart, TooltipComponent, GridComponent, CanvasRenderer])

@Component({
  selector: 'spb-e-loan-chart',
  imports: [NgxEchartsDirective],
  templateUrl: './e-loan-chart.component.html',
  styleUrl: './e-loan-chart.component.scss',
  providers: [
    provideEchartsCore({echarts}),
    {provide: PrintableChartComponent, useExisting: ELoanChartComponent}
  ]
})
export class ELoanChartComponent extends PrintableChartComponent implements OnChanges {

  public loans = input.required<KalpLoan[]>()

  public option: EChartsOption = {
    tooltip: {
      trigger: 'item',
      valueFormatter: (v: any) => `${v.toLocaleString('sv-SE')} kr`
    },
    color: COLOR_LIST,
    series: [
      {
        type: 'pie',
        label: {
          show: false
        },
        data: []
      }
    ]
  }

  public myChart!: EChartsType

  public chartInit(e: EChartsType) {
    this.myChart = e
  }

  public override print(): string {
    return this.myChart.getDataURL({
      pixelRatio: 50,
      backgroundColor: '#fff'
    })
  }

  public ngOnChanges() {
    const option: any = this.option
    option.series[0]!.data = this.loans()
      .toSorted((a, b) => a.expires - b.expires || a.terms - b.terms)
      .map((loan: KalpLoan, index: number) => {
        return {
          name: index + 1 + '.',
          value: loan.amount
        }
      })
    // Must replace to trigger upddate
    this.option = {...this.option}
  }
}
